<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          v-for="(item, i) in filteredCategories"
          :key="i"
          class="py-6 px-md-6"
          cols="12"
          md="6"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :help-data="helpData"
                :label="`${item.name}`"
                :service-name="serviceName"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
                class="buttoninfo"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catSocialNetwork",

  components: { CatCard },

  data: () => ({
    serviceName: "Qrland",
    helpData: [],
    componentName: "cat-share",
  }),
  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
  computed: {
    categories() {
      return [
       
        {
          name: this.$t("categories.social_media"),
          value: "",
          route: "qr.socialMedia",
          colors: ["#1E6F5C", "#29BB89", "#289672"],
          icon: "mdi-instagram",
        },
        {
          name: "بله",
          value: "",
          route: "qr.bale", 
          colors: ["#4CD6AE", "#3D9196", "#324A7D"],
          image: "/media/socialnetwork/icon/bale.webp", 
          isTest: true,

        },
        {
          name: "روبیکا",
          value: "",
          route: "qr.robika", 
          colors: ["#7c25c7", "#E45153", "#F4AA32"],
          image: "/media/socialnetwork/icon/robika.webp", 
          isTest: true,

        },
        {
          name: "ایتا",
          value: "",
          route: "qr.eitaa", 
          colors: ["#B84C24", "#fa8945", "#F05E28"],
          image: "/media/socialnetwork/icon/eitaa.webp",
          isTest: true,

        },
      ];
    },
    filteredCategories() {
      const currentLocale = this.$i18n.locale;
      if (currentLocale === "fa") {
        return this.categories;
      }
      return this.categories.map((x) => ({
        ...x,
        comingSoon: x.route !== "qr.cardVisit",
      }));
    },
  },
};
</script>

<style scoped></style>
